import { useState } from "react"
import { createPortal } from "react-dom"
import { useCookies } from "react-cookie"
import Lesson from "./Lesson"
import AddLessonForm from "../NewForm/AddLessonForm"
import LessonDeleteModal from "./LessonDeleteModal"
import LessonTableRow from "./LessonTableRow"

function LessonHandler({ data, deleteHandler, userPrefs, setUserPrefs }) {
    const [ isEditing, setIsEditing ] = useState(false)
    const [ isDeleting, setIsDeleting ] = useState(false)

    const root = document.querySelector(".App")

    return <>
    {
        isEditing
            ? createPortal(<AddLessonForm 
                clickHandler={() => setIsEditing(false)}
                createHandler={() => {
                    // forteaza update react
                    setUserPrefs({ ...userPrefs, fetchRequested: true })
                }}
                modifyingLesson={data}
            />, root)
            : null
    }
    {
        isDeleting
            ? createPortal(<LessonDeleteModal 
                lessonId={data.id}
                closeHandler={() => setIsDeleting(false)}
                deleteHandler={deleteHandler}
            />, root)
            : null 
    }
    {
        userPrefs.useOldList
            ? <Lesson 
                data={data} 
                handleEdit={() => setIsEditing(true)} 
                handleDelete={() => setIsDeleting(true)} 
            />
            : <LessonTableRow
                data={data}
                handleEdit={() => { 
                    setIsEditing(true) 
                }}
                handleDelete={() => setIsDeleting(true)}
            />
    }
    </>
}

export default LessonHandler